import { createMutationAtom } from 'atoms/create-resource-atom';
import type { VerificationItemEventResponse } from 'types/api-responses';

// Posts a tri-state verdict to /verification_items/:id/events; reused by
// every task card in the panel.
export const verificationTaskEventAtom = createMutationAtom<
  VerificationItemEventResponse,
  'verificationItemEvent'
>();
